import styled from 'styled-components';
import React from 'react';
import {BREAKPOINTS, COLORS, focusStyles} from '../styles';
import {ComponentMStyling, ComponentTextStyle} from '../styles/typography';
import {Z_INDEXES} from '../styles/z-indexes';
import {useFocusVisibleRef} from '../common';
import { useNavigation } from '../Navigation';

export const NavItemDiv = styled.div`
  ${props => ComponentMStyling(ComponentTextStyle.Regular, COLORS.generateToken({componentType:'text',defaultVariant:'subtle'}, props.theme))}

  margin: 0;
  padding: 0 21px 0 21px;
  height: 64px;

  ${BREAKPOINTS.LARGE} {
    height: 80px;
  }

  display: flex;
  align-items: center;
  text-align: center;
  position: relative;

  &:after {
    content: '';
    display: block;
    position: absolute;
    background-color: transparent;
    height: 3px;
    border-radius: 3px;
    left: 2px;
    right: 2px;
    bottom: 2px;
  }

  &.active:not(.disabled) {
    z-index: ${Z_INDEXES.active};
    background-color: ${props => COLORS.getColor('neutral_20', props.theme)};
    color: ${props => COLORS.getColor('neutral_800', props.theme)};

    &:after {
      background-color: ${props => COLORS.getColor('primary_600', props.theme)};
    }
  }

  &.disabled {
    color: ${props => COLORS.getColor('neutral_300', props.theme)};
    background-color: ${props => COLORS.getColor('neutral_100', props.theme)};

    &:after {
      background-color: ${props => COLORS.getColor('neutral_100', props.theme)};
    }
  }

  &:hover:not(.disabled) {
    z-index: ${Z_INDEXES.hover};
    background-color: ${props => COLORS.getColor('primary_20', props.theme)};
    color: ${props => COLORS.getColor('primary_700', props.theme)};

    &:after {
      background-color: ${props => COLORS.getColor('primary_700', props.theme)};
    }
  }

  &:active:not(.disabled) {
    z-index: ${Z_INDEXES.active};
    background-color: ${props => COLORS.getColor('primary_100', props.theme)};
    color: ${props => COLORS.getColor('primary_800', props.theme)};

    &:after {
      background-color: ${props => COLORS.getColor('primary_800', props.theme)};
    }
  }


  &:focus:not(.disabled) {
    ${focusStyles}
    outline-offset: -4px;
  }
`;

const NavItem = (props: any) => {
  const {isActiveRoute} = useNavigation();
  return (
    <NavItemDiv {...props} className={props?.className + (props?.href && isActiveRoute && isActiveRoute(props.href, props.exact ?? false) ? ' active' : '')} />
  );
};

export default NavItem;
